import e from"./StateResults.vue_vue&type=script&lang.js";import{render as t}from"./StateResults.vue_vue&type=template&id=2ea5b184&lang.js";e.render=t;export default e;
//# sourceMappingURL=StateResults.vue.js.map
